import React,{ useState, useEffect } from 'react';
import { Alert } from 'antd';

import ModemCoax from '../../images/hardware-setup/modem-coaxial-cable-icon.png';
import ModemPower from '../../images/hardware-setup/modem-power-adapter-icon.png';
import ModemTOCPU from '../../images/hardware-setup/connect-modem-to-cpu.png';
import Timer from '../../images/hardware-setup/timer-icon.png';
import Diagram from '../../images/hardware-setup/diagram.png';

import ConnectWireless from '../../images/hardware-setup/connect-wireless.png';
import ConnectEthernet from '../../images/hardware-setup/connect-ethernet.png';
import ModemWan from '../../images/hardware-setup/modem-wan-icon.png';
import ModemPowerConnect from '../../images/hardware-setup/connect-power-modem.png';
import RouterDiagram from '../../images/hardware-setup/router-diagram.png';

const siteDomain = headerVars.siteDomain;

function ModemSetup() {
    return (
        <div id="modem-setup-component" className="modem-setup-component">
            <h2>Cable Modem Set Up</h2>

            <h4>Connecting Your Cable Modem to a Router</h4>
            <div className='modem-setup-walkthrough-container'>
                <div className='modem-setup-walkthrough-item'>
                    <div className='walkthrough-item-desc'>
                        <div className='step-number'>1</div>
                        <ol>
                            <li>Connect the modem to the coaxial cable.</li>
                            <li>Power the modem using the supplied power adapter.</li>
                        </ol>
                    </div>
                    <div className='step-image'>
                        <div className='step-number'>2</div>
                        <img src={ ModemPowerConnect } />
                    </div>
                </div>
                <div className='modem-setup-walkthrough-item'>
                    <div className='walkthrough-item-desc'>
                        <div className='step-number'>3</div>
                        <p>Connect the modem to the WAN/Internet port using the Ethernet cable.</p>
                        <p style={{ fontStyle:"italic" }}>Do not use the USB modem connection.</p>
                    </div>
                    <div className='step-image'>
                        <img src={ ModemWan } />
                        <div style={{ fontSize: '0.8rem', padding: '0.5rem', marginTop: '0.5rem' }} className='diagram-container'>Allow 10-15 minutes to the modem to register on the cable network.</div>
                    </div>
                </div>
                <div className='modem-setup-walkthrough-item'>
                    <div className='walkthrough-item-desc'>
                        <p style={{ fontWeight: 600 }}>To connect with an ethernet cable.</p>
                        <p>Connect wired devices directly to your router using the LAN ports on the router.</p>
                    </div>
                    <div className='step-image'>
                        <img src={ ConnectEthernet } />
                    </div>
                </div>
                <div className='modem-setup-walkthrough-item'>
                    <div className='walkthrough-item-desc'>
                        <p style={{ fontWeight: 600 }}>To connect wirelessly</p>
                        <p>Ensure WiFi is enabled on your device and begin looking for your connection on your WiFi menu.</p>
                    </div>
                    <div className='step-image'>
                        <img src={ ConnectWireless } />
                    </div>
                </div>
            </div>
            <span style={{ display:'block', fontWeight: 600, fontSize:'0.9rem' }}>Router Diagram</span>
            <div className='diagram-container'>
                <img src={ RouterDiagram } />
            </div>
            <p style={{ marginTop:'1rem', marginBottom: '6rem', fontSize:'0.9rem' }}>When troubleshooting connectivity issues, remove the router and connect your modem directly to your computer using the Ethernet cable. If you still cannot browse the internet after removing the router from your setup, please contact support.</p>

            <h4>Connecting Your Cable Modem to a Computer</h4>
            <div className='modem-setup-walkthrough-container'>
                <div className='modem-setup-walkthrough-item'>
                    <div className='walkthrough-item-desc'>
                        <div className='step-number'>1</div>
                        <p>Connect the modem to the coaxial cable.</p>
                    </div>
                    <div className='step-image'>
                        <img src={ ModemCoax } />
                    </div>
                </div>
                <div className='modem-setup-walkthrough-item'>
                    <div className='walkthrough-item-desc'>
                        <div className='step-number'>2</div>
                        <p>Power the modem using the supplied power adapter.</p>
                    </div>
                    <div className='step-image'>
                        <img src={ ModemPower } />
                    </div>
                </div>
                <div className='modem-setup-walkthrough-item'>
                    <div className='walkthrough-item-desc'>
                        <div className='step-number'>3</div>
                        <p>Connect the modem to your computer using the Etherent cable.</p>
                        <p style={{ fontStyle:"italic" }}>Do not use the USB modem connection.</p>
                    </div>
                    <div className='step-image'>
                        <img src={ ModemTOCPU } />
                    </div>
                </div>
                <div className='modem-setup-walkthrough-item'>
                    <div className='walkthrough-item-desc'>
                        <div className='step-number'>4</div>
                        <p>Wait 10-15 minutes for your modem to register. Your computer will now have access to the internet.</p>
                    </div>
                    <div className='step-image'>
                        <img src={ Timer } />
                    </div>
                </div>
            </div>
            <span style={{ display:'block', fontWeight: 600, fontSize:'0.9rem' }}>Cable Modem Diagram</span>
            <div className='diagram-container'>
                <img src={ Diagram } />
            </div>
            <p style={{ marginTop:'1rem', marginBottom: '2rem', fontSize:'0.9rem' }}>Your modem has been pre-configured specifically for your Start.ca internet account.Contact us for assistance if modem has not registered within 2 hours of the initial installation.</p>

            <Alert 
                message="If you are still not seeing a connection after 1 hour, please find a paper clip or pin and insert it in the reset button area and hold until all the lights blink on the modem.  The modem will take up to 10 minutes to come online, then connect to your router and you should be good to go!" 
                type="info" 
                showIcon />
        </div>
    )
}

export default ModemSetup